import { i18n } from '@/plugins/i18n'


export default [
    {
        field: 'id',
        width: 50,
        title: "#",
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'holiday_date',
        title: i18n.t('label.accounting_holiday_date'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    },
]